class SkillsGridComponent extends React.Component{	
	constructor(props) {
    super(props);
    this.state = {
			
		};
		//this.captureDiv = this.captureDiv.bind(this);
		//this.testTapDuration = this.testTapDuration.bind(this);
		
  }
	
	render(){
		
		return (
			<div className="about__block__skills__matrix">
				<div className="skills__matrix">
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle html5">
									HTML5
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle css3">
									CSS3
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle javascript">
									JavaScript
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle sass">
									SASS
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle gulp">
									React
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle jquery">
									Redux
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle react">
									Vue.js
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle bem">
									JQuery
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle oop">
									OOP
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle svg">
									SVG
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle greensock">
									VCS
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle pwa">
									PWA
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle semantichtml5">
									Semantic HTML5
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle jsdesignpatterns">
									JS Design Patterns
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle java">
									JAVA
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle php">
									PHP
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-2 col-md-1">
						<div className="skill__bubble__container">
							<div className="skill__bubble__inner__container">
								<div className="skill__bubble__circle responsivewebdesign">
									Responsive Design
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export { SkillsGridComponent };


// WEBPACK FOOTER //
// in/js/custom-components/about/skills-grid-component.js